import { render, staticRenderFns } from "./u-scrolldown-double-arrow.vue?vue&type=template&id=69def2b8&scoped=true&"
import script from "./u-scrolldown-double-arrow.vue?vue&type=script&lang=js&"
export * from "./u-scrolldown-double-arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69def2b8",
  null
  
)

export default component.exports